import { useMutation } from '@tanstack/react-query';
import { withBasePath } from '@/utils/withBasePath';

export function useMarkAnnouncementSeen() {
  return useMutation({
    mutationFn: async (organizerId: string) => {
      const res = await fetch(
        withBasePath(
          `/api/organizers/${encodeURIComponent(organizerId)}/super-organizer-announcement`,
        ),
        { method: 'PATCH', credentials: 'include' },
      );
      if (!res.ok) {
        throw new Error(`Failed to mark announcement seen: ${res.status}`);
      }
    },
  });
}
